module.exports={render:function (){with(this) {
  return _h('header', {
    staticClass: "ion-header",
    class: [cTheme]
  }, [_t("default")])
}},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b43ed2c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/src/header.vue
// module id = 167
// module chunks = 0